export class BusinessMediaInfo {
    facebookURL: any | undefined; 
    twitterURL: any | undefined; 
    instagramURL: any | undefined; 
    youTubeURL: any | undefined;
    status?: boolean ; 
}
